import React, { Component } from 'react';

import './Priority.scss';

class Priority extends Component {
  render() {
    return (
      <div className="Priority">
        <span className="label">Medium</span>
      </div>
    )
  }
}

export default Priority;
